import React from 'react';
import { Link } from 'react-router-dom';

import { MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { withRouter, remCss, lang, permissions } from 'src/helpers';

import model from 'src/pages/admin/auth/model';

const apiStateId = 'password';

class Login extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  handleSubmit = (event) => {
    event.preventDefault();
    model.loginPassword();
  };

  render() {
    const { handleChange, handleBlur } = model;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;

    return (
      <div className={'mc-page-auth-box'}>
        <div className={'mc-box-header'}>
          <h4 className='mc-box-title'>{lang.t('Login')}</h4>
          <div className='mc-box-title-note'></div>
        </div>
        {createState.error && <p data-testid='login-error' className='mc-error'>{createState.errorMessage}</p>}
        <form className='mc-form' onSubmit={this.handleSubmit}>
          <TextField
            type='email'
            template={6}
            autoFocus={true}
            name={'username'}
            value={model.input('username')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            label={'Email Address'}
            invalid={invalid}
          />
          <TextField
            template={6}
            type='password'
            name={'password'}
            labelHtml={
              <>
                <span>{lang.t('Password')}</span>
                <Link
                  to={permissions.PAGES.ADMIN_FORGOT_PASSWORD_PAGE.path}
                  className='mc-forgot-pw-link'
                  style={{ fontSize: remCss(16) }}
                >
                  {lang.t('Forgot password?')}
                </Link>
              </>
            }
            value={model.input('password')}
            onChange={(n, v) => {
              model.resetApiState(apiStateId);
              handleChange(n, v);
            }}
            onBlur={handleBlur}
            invalid={invalid}
          />
          <MCButton
            data-testid='login-submit-button'
            dark
            primary
            large
            radius
            disabled={createState.loading}
            type='submit'
          >
            {lang.t(createState.loading ? 'Logging in...' : 'Login')}
          </MCButton>
        </form>
      </div>
    );
  }
}

export default withRouter(Login);
